import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import qs from "qs";
import { useDispatch } from "react-redux";
import { useSigninWithCode } from "../utils/authHelpers";
import { SET_WARNING, CLOSE_WARNING } from "../actions/type";
import {
  default as ACCESS_LEVELS,
  ADMINS,
  STUDENT
} from "../config/accessLevels";

const MyBestUserLogin = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const signinWithCode = useSigninWithCode();
  const dispatch = useDispatch();

  useEffect(() => {
    const search = qs.parse(location.search, { ignoreQueryPrefix: true });

    signinWithCode(search.code)
      .then(({ data }) => {
        const roles = data.signinWithCode.me.roles;

        // Check localStorage first (persists after logout)
        let previousUrl = localStorage.getItem("tabletReturnPath");
        console.log("[MyBestUserLogin] tabletReturnPath:", previousUrl);
        if (previousUrl) {
          // Clear it after reading
          localStorage.removeItem("tabletReturnPath");
        }

        // Fallback to sessionStorage if no tabletReturnPath
        if (!previousUrl) {
          previousUrl = sessionStorage.getItem("previousURL");
          console.log("[MyBestUserLogin] previousURL from sessionStorage:", previousUrl);
          if (previousUrl) {
            sessionStorage.removeItem("previousURL");
          }
        }

        // Determine the user's role-based route
        const userRoleRoute = roles.some((role) =>
          ACCESS_LEVELS[ADMINS].includes(role)
        )
          ? "admin"
          : roles.some((role) => ACCESS_LEVELS[STUDENT].includes(role))
          ? "student"
          : "teacher";

        console.log("[MyBestUserLogin] userRoleRoute:", userRoleRoute);

        if (!previousUrl) {
          console.log("[MyBestUserLogin] No previousUrl, navigating to:", `/${userRoleRoute}`);
          navigate(`/${userRoleRoute}`);
        } else {
          console.log("[MyBestUserLogin] Original previousUrl:", previousUrl);
          // Transform the path to match the logged-in user's role
          // Replace the role segment (admin/teacher/student) with the actual user's role
          const pathSegments = previousUrl.split("/").filter(Boolean);
          console.log("[MyBestUserLogin] pathSegments:", pathSegments);

          if (pathSegments.length > 0) {
            const firstSegment = pathSegments[0];
            console.log("[MyBestUserLogin] firstSegment:", firstSegment);

            // Check if first segment is a role (admin/teacher/student)
            if (
              firstSegment === "admin" ||
              firstSegment === "teacher" ||
              firstSegment === "student"
            ) {
              // Replace with user's actual role
              pathSegments[0] = userRoleRoute;
              previousUrl = "/" + pathSegments.join("/");
              console.log("[MyBestUserLogin] Transformed previousUrl:", previousUrl);
            }
          }

          console.log("[MyBestUserLogin] Final navigate to:", previousUrl);
          navigate(previousUrl);
        }
      })
      .catch((error) => {
        dispatch({
          type: SET_WARNING,
          payload: {
            alert: error.message,
            confirm: () => {
              dispatch({ type: CLOSE_WARNING, payload: {} });
              navigate("/");
            }
          }
        });
      });
  }, [signinWithCode, navigate, location, dispatch]);

  return null;
};

export default MyBestUserLogin;

